import axios from "./axios";

const TestimonialService = {
  getBusiness: async (restaurant_id) => {
    try {
      const response = await axios.get(`/business/${restaurant_id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateBusiness: async (restaurant_id, payload) => {
    try {
      const response = await axios.put(`/business/${restaurant_id}`, payload);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getTestimonials: async (restaurant_id) => {
    try {
      const response = await axios.get("/testimonial", restaurant_id);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },

  addTestimonial: async (testimonial) => {
    try {
      const response = await axios.post(`/testimonial`, testimonial);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateTestimonial: async (testimonial, id) => {
    try {
      const response = await axios.put(`/testimonial/${id}`, testimonial);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  deleteTestimonial: async (id) => {
    try {
      const response = await axios.delete(`/testimonial/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getCusines: async () => {
    try {
      const response = await axios.get(`/cuisines`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getRestaurant: async () => {
    try {
      const response = await axios.get(`/restaurants`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getSpecialities: async (id) => {
    try {
      // const payload = {"specialty": "Specialty 2"}
      // const responseAdd = await axios.post(`/restaurant/${id}/specialty`,payload);
      const response = await axios.get(`/restaurant/${id}/specialties`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  addRestaurant: async (data) => {
    try {
      const response = await axios.post(`/restaurants`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
      throw new Error("Failed to Add restaurant. Please try again later.");
    }
  },
  updateRestaurant: async (testimonial, id) => {
    try {
      const response = await axios.put(`/restaurants/${id}`, testimonial);
      return response.data.data;
    } catch (e) {
      console.error(e);
      throw new Error("Failed to update restaurant. Please try again later.");
    }
  },
  addEmployee: async (testimonial) => {
    try {
      const response = await axios.post(`/employee`, testimonial);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateEmployee: async (testimonial, id) => {
    try {
      const response = await axios.put(`/employee/${id}`, testimonial);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  deleteEmployee: async (id) => {
    try {
      const response = await axios.delete(`/employee/${id}`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getEmployees: async () => {
    try {
      const response = await axios.get("/employee");
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getUsers: async () => {
    try {
      const response = await axios.get("/users");
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  uploadPhoto: async (photo) => {
    try {
      const response = await axios({
        url: "/uploads/image",
        method: "POST",
        data: photo,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.data.data && response.data.data.url) {
        return response.data.data;
      }
    } catch (e) {
      console.error(e);
    }
  },
  getRestaurantCode: async (code) => {
    try {
      const response = await axios.get(`/restaurants/code/${code}`);
      return response.data.data;
    } catch (e) {
        return e.response.data || e;
    }
  },
};

export default TestimonialService;
